<template>
  <div class="add-form">
    <div class="list-title">
      新增用户组
    </div>
    <group-form :form="form" ref="form" create>
      <template #button>
        <el-form-item>
          <el-button type="primary" plain size="small" :loading="loading" @click="submit">
            {{ $t("handle.submit") }}
          </el-button>
        </el-form-item>
      </template>
    </group-form>
  </div>
</template>

<script>
import GroupForm from "./Form.vue";
import { groupAdd } from "api/group";

export default {
  components: {
    GroupForm
  },

  data() {
    return {
      form: {
        name: "",
        organizationUUID: "",
        description: "",
        bindings: {
          groupUserBindings: [],
          groupUserRoleBindings: []
        }
      },

      loading: false
    };
  },

  methods: {
    submit() {
      this.$refs["form"].$refs["form"].validate(valid => {
        if (valid) {
          let groupUserBindings = this.$refs["form"].groupUserBindings;
          let groupUserRoleBindings = this.$refs["form"].groupUserRoleBindings;
          let effectBindings = this.$refs["form"].effectBindings;

          this.form.organizationUUID = this.organization;

          this.form.bindings = {
            groupUserBindings: [],
            groupUserRoleBindings: []
          };

          for (let key in groupUserRoleBindings) {
            this.form.bindings.groupUserRoleBindings.push({
              providerUUID: key,
              roleUUID: groupUserRoleBindings[key],
              effect: effectBindings[key],
              organizationUUID: this.organization
            });
          }

          this.form.bindings.groupUserBindings = groupUserBindings.map(item => {
            return {
              userUUID: item,
              organizationUUID: this.organization
            };
          });

          this.loading = true;
          groupAdd(this.form).then(response => {
            this.loading = false;
            if (response.code === 0) {
              this.$router.push("/admin/group");
              this.$store.dispatch("app/getUserInfo");
            }
          });
        }
      });
    }
  },

  computed: {
    organization() {
      return this.$store.state.app.organization;
    }
  }
};
</script>

<style></style>
